/**
 * Integration Domain Types
 *
 * Re-exports integration config types from data-access.
 * The canonical type definitions live in @rammetec/data-access
 * since they are infrastructure concerns used by the factory.
 */
export const INTEGRATION_CONFIG = 'IntegrationConfig';
export { IntegrationType, IntegrationAuthType, } from '@rammetec/data-access';
//# sourceMappingURL=integration.js.map